// extracted by mini-css-extract-plugin
module.exports = {"phantomFull":"ArticlePreview-module--phantom-full--1j0Y0","postPreview":"ArticlePreview-module--postPreview--1UGJx","link":"ArticlePreview-module--link--1-Dah"};